module.exports = __webpack_public_path__ + "65960147f6a914e445dcc8f91eadc441.png";